module.exports = __webpack_public_path__ + "windowsHello_70x70.17f797e4b0af646c979faf08931ef909.png";